function qjdInitialize(){
  document.querySelectorAll('.qjd .dc-profile>img,.qjd .bp-doctor>img,.qjd-gallery img').forEach(image=>{
    if(image.closest('.qjd-photo-frame'))return;
    const frame=document.createElement('span');
    frame.className='qjd-photo-frame';
    const backdrop=image.cloneNode(false);
    backdrop.removeAttribute('id');
    backdrop.removeAttribute('style');
    backdrop.className='qjd-photo-backdrop';
    backdrop.alt='';
    backdrop.setAttribute('aria-hidden','true');
    image.parentNode.insertBefore(frame,image);
    frame.append(backdrop,image);
    image.classList.add('qjd-photo-main');
  });
  document.querySelectorAll('.qjd-directory').forEach(root=>{
    if(root.dataset.qjdReady)return;
    root.dataset.qjdReady='true';
    const cities=Array.from(root.querySelectorAll('.dc-city'));
    root.querySelectorAll('.dc-doctor').forEach(doctor=>{doctor.open=true});
    function locationId(hash){
      let id;try{id=decodeURIComponent(hash.slice(1)).toLowerCase()}catch{return ''}
      return id==='snellville'?'atlanta':id;
    }
    function selectLocation(id){
      const city=cities.find(item=>item.id===id);
      root.querySelectorAll('.dc-location-links a').forEach(link=>{
        if(locationId(link.hash)===id&&city)link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
      cities.forEach(item=>{
        item.style.display=city&&item!==city?'none':'';
        item.open=item===city;
        if(item===city)item.querySelectorAll('.dc-doctor').forEach(doctor=>{doctor.open=true});
      });
    }
    cities.forEach(city=>city.addEventListener('toggle',()=>{
      if(city.open){city.querySelectorAll('.dc-doctor').forEach(doctor=>{doctor.open=true})}
    }));
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const url=new URL(link.href,location.href);
      const id=locationId(url.hash);
      if(url.origin!==location.origin||url.pathname!==location.pathname||!cities.some(city=>city.id===id))return;
      event.preventDefault();
      event.stopPropagation();
      if(location.hash!==url.hash)history.pushState(null,'',url.pathname+url.search+url.hash);
      selectLocation(id);
      const drawer=link.closest('header-drawer');
      if(drawer&&typeof drawer.closeMenuDrawer==='function')drawer.closeMenuDrawer(event,drawer.querySelector('summary'));
    },true);
    window.addEventListener('hashchange',()=>selectLocation(locationId(location.hash)));
    window.addEventListener('popstate',()=>selectLocation(locationId(location.hash)));
    selectLocation(locationId(location.hash));
  });
  document.querySelectorAll('.qjd-film').forEach(film=>{
    if(film.dataset.qjdFilmReady)return;
    film.dataset.qjdFilmReady='true';
    const main=film.querySelector('.qjd-film-main');
    const backdrop=film.querySelector('.qjd-film-backdrop');
    if(!main||!backdrop)return;
    function align(){
      if(backdrop.readyState<1)return;
      if(Math.abs(backdrop.currentTime-main.currentTime)>.12)backdrop.currentTime=main.currentTime;
      backdrop.playbackRate=main.playbackRate;
    }
    function playBackdrop(){
      align();
      if(main.paused||main.ended)return;
      const playing=backdrop.play();if(playing)playing.catch(()=>{});
    }
    main.addEventListener('play',playBackdrop);
    main.addEventListener('playing',playBackdrop);
    main.addEventListener('pause',()=>{backdrop.pause();align()});
    main.addEventListener('waiting',()=>backdrop.pause());
    main.addEventListener('ended',()=>backdrop.pause());
    ['seeking','seeked','timeupdate','ratechange'].forEach(event=>main.addEventListener(event,align));
    backdrop.addEventListener('loadedmetadata',playBackdrop);
    playBackdrop();
  });
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)document.querySelectorAll('.qjd-film video').forEach(video=>{video.autoplay=false;video.pause()});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',qjdInitialize);else qjdInitialize();
document.addEventListener('shopify:section:load',qjdInitialize);
